import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import {
    IProxyApiListResponse,
    IProxyImportResponse,
    IProxySpeedtestParams,
    IProxySpeedtestResponse,
    IProxyUpdateParams,
    IProxyUpdateResponse,
} from '@/types/proxy';

export const proxyList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IProxyApiListResponse>> => {
    return axios.get('/api/proxy/list', { ...config, params });
};

export const proxyUpdate = (params: IProxyUpdateParams): Promise<AxiosResponse<IProxyUpdateResponse>> => {
    return axios.post('/api/proxy/update', params);
};

export const proxyCreate = (params: IProxyUpdateParams): Promise<AxiosResponse<IProxyUpdateResponse>> => {
    return axios.post('/api/proxy/create', params);
};

export const proxyDelete = (params: IProxyUpdateParams): Promise<AxiosResponse<IProxyUpdateResponse>> => {
    return axios.post('/api/proxy/delete', params);
};

export const proxySpeedtest = (params: IProxySpeedtestParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IProxySpeedtestResponse>> => {
    return axios.get('/api/proxy/speedtest', { ...config, params });
};

export const proxyImport = (inputText: string, config?: AxiosRequestConfig): Promise<AxiosResponse<IProxyImportResponse>> => {
    return axios.post('/api/proxy/import', null, { ...config, params: { inputText } });
};
